// extracted by mini-css-extract-plugin
export var display1 = "c8Nbl";
export var display2 = "cHsTe";
export var headline1 = "a3leH";
export var headline2 = "W9DSn";
export var headline3 = "kH+ET";
export var headline4 = "-B+x2";
export var headline5 = "_0agzy";
export var intro = "jtiyo";
export var lead = "pLtNB";
export var pageTitle = "aat-k";
export var quote = "w9V7m";
export var quoteIcon = "_7m1AC";